export const locationController = () => {
    var companyName = process.env.REACT_APP_LOCATION;
    var companyId =
      companyName === "toroslar"
        ? 3
        : companyName === "baskent"
        ? 1
        : companyName === "ayedas"
        ? 2
        : "";
  
    return companyId;
  };
  